export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },

    showPatientAppointmentTable ({commit}) {
        commit('showPatientAppointmentTable');
    },

    showPatientDisbandTable ({commit}) {
        commit('showPatientDisbandTable');
    },

    showPatientAttendanceWrapper ({commit}) {
        commit('showPatientAttendanceWrapper');
    },

    showPatientAttendanceTable ({commit}) {
        commit('showPatientAttendanceTable');
    },

    showPatientAttendanceDetails ({commit}) {
        commit('showPatientAttendanceDetails');
    },

    showPatientAttendanceEKatalogusForm ({commit}) {
        commit('showPatientAttendanceEKatalogusForm');
    },

    showCovidRapidAntigenTestForm ({commit}) {
        commit('showCovidRapidAntigenTestForm');
    },


    showPatientEvidenceContent({commit}) {
        commit('showPatientEvidenceContent');
    },
    showPatientEvidenceForm({commit}) {
        commit('showPatientEvidenceForm');
    },
    showPatientEvidenceFormFinalize({commit}) {
        commit('showPatientEvidenceFormFinalize');
    },
    showEHREvidenceForm({commit}) {
        commit('showEHREvidenceForm');
    }
}
